import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

const api = axios.create({ baseURL });
  /*
  headers: {
    'Content-Type': 'application/json',
  },
});
*/

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('vedanta_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
